import React from "react";
import {
  Popover,
  IconButton,

  MenuList,
  MenuItem,
  ListItemIcon,
  ListItemText
} from "@mui/material";
import {
  makeStyles
} from "@mui/styles";
import {
  MoreHoriz as MoreHorizIcon
} from "@mui/icons-material";
import PopupState, {
  bindTrigger,
  bindPopover
} from "material-ui-popup-state";

const TableRowAction = ({ customItems, onEdit, onDelete }) => {
  const classes = useStyles();

  const handleEdit = (popupState) => {
    popupState.close();
    onEdit();
  }
  const handleDelete = (popupState) => {
    popupState.close();
    onDelete();
  }
  const handleClickCustom = (popupState, _item) => {
    popupState.close();
    _item.onClick();
  }

  return (
    <PopupState>
      {(popupState) => (
        <div>
          <IconButton {...bindTrigger(popupState)}>
            <MoreHorizIcon/>
          </IconButton>
          <Popover
            {...bindPopover(popupState)}
            anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
            transformOrigin={{vertical: 'top', horizontal: 'right'}}
          >
            <MenuList className={classes.menuList}>
              {Boolean(!!onEdit) && (
                <MenuItem onClick={handleEdit.bind(this, popupState)}>
                  <ListItemText>Редактировать</ListItemText>
                  <ListItemIcon>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10.8706 3.8004L3.45176 11.6529C3.17164 11.9511 2.90055 12.5385 2.84633 12.9451L2.51199 15.8729C2.39452 16.9301 3.15357 17.653 4.20178 17.4723L7.11146 16.9753C7.51809 16.903 8.08738 16.6048 8.3675 16.2976L15.7863 8.44505C17.0694 7.0896 17.6478 5.5444 15.6507 3.65582C13.6628 1.78531 12.1537 2.44495 10.8706 3.8004Z" stroke="#566B7D" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M9.63184 5.1106C10.0204 7.60461 12.0445 9.51126 14.5566 9.76428" stroke="#566B7D" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </ListItemIcon>
                </MenuItem>
              )}
              {Boolean(!!onDelete) && (
                <MenuItem onClick={handleDelete.bind(this, popupState)}>
                  <ListItemText>Удалить</ListItemText>
                  <ListItemIcon>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M16.833 5.48511C14.3355 5.23761 11.823 5.11011 9.31801 5.11011C7.83301 5.11011 6.34801 5.18511 4.86301 5.33511L3.33301 5.48511" stroke="#566B7D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M7.45801 4.7275L7.62301 3.745C7.74301 3.0325 7.83301 2.5 9.10051 2.5H11.0655C12.333 2.5 12.4305 3.0625 12.543 3.7525L12.708 4.7275" stroke="#566B7D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M15.2213 7.85498L14.7338 15.4075C14.6513 16.585 14.5838 17.5 12.4913 17.5H7.67629C5.58379 17.5 5.51629 16.585 5.43379 15.4075L4.94629 7.85498" stroke="#566B7D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M8.20801 10.375H11.958" stroke="#566B7D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </ListItemIcon>
                </MenuItem>
              )}
              {(customItems || []).map((_item) => (
                <MenuItem onClick={handleClickCustom.bind(this, popupState, _item)}>
                  <ListItemText>{ _item.label }</ListItemText>
                  <ListItemIcon>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9 11V17L11 15" stroke="#3A3A3A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M9 17L7 15" stroke="#3A3A3A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14" stroke="#3A3A3A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M22 10H18C15 10 14 9 14 6V2L22 10Z" stroke="#3A3A3A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </ListItemIcon>
                </MenuItem>
              ))}
            </MenuList>
          </Popover>
        </div>
      )}
    </PopupState>
  )
}

const useStyles = makeStyles((theme) => ({
  menuList: {
    "& .MuiButtonBase-root": {
      padding: "10px 20px",
      boxSizing: "border-box",
      "&:hover": {
        backgroundColor: "#EBEEF7",
        "& .MuiListItemIcon-root svg path": {
          stroke: "#635EF2"
        },
        "& .MuiListItemText-root .MuiTypography-root": {
          color: "#635EF2"
        }
      }
    },
    "& .MuiListItemIcon-root": {
      width: 20, height: 20,
      minWidth: 20,
      marginLeft: "10px"
    },
    "& .MuiListItemText-root .MuiTypography-root": {
      fontSize: 14,
      color: "#566B7D",
      fontWeight: "500",
      lineHeight: "16px",
      textAlign: "right",
    }
  }
}));

export default TableRowAction
